import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useAppSelector } from "../redux/typedHooks";
import { useEffect, useState } from "react";
import { showToast } from "../utils/toast";
import { getUserType } from "../utils/getUserType";
import AccountRevokedScreen from "../components/AccountRevoked/AccountRevokedScreen";
import BaseLoading from "../components/Loader/BaseLoading";
import React from "react";

const CheckAccess = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);

  const [isValidated, setIsValidated] = useState(false);
  const [isAgeProofed, setIsAgeProofed] = useState(false);
  const [isRevoked, setIsRevoked] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const user = useAppSelector<{
    firstName: string;
    lastName: string;
    email: string;
    DOB: string;
    isOnboarding: boolean;
    ageProofed: boolean;
    revoke: boolean;
    isAdmin: boolean;
    userType: {
      _id: number;
      title: string;
    };
  } | null>(state => state.user.currentUser);

  useEffect(() => {
    if (!user) {
      // Перевіряємо, чи користувач раніше реєструвався/входив
      const hasRegisteredOrLoggedIn = localStorage.getItem("hasRegisteredOrLoggedIn");
      if (hasRegisteredOrLoggedIn === "true") {
        history.push("/login");
      } else {
        history.push("/register");
      }
      return;
    }

    const userType = getUserType(user);
    const userTypeTitle = userType?.title?.toLowerCase();

    setIsValidated(user.isOnboarding);

    setIsAgeProofed(
      userTypeTitle === "viewer" ? user.isOnboarding : user.ageProofed
    );

    const computedRevoked = userTypeTitle === "viewer" ? false : user.revoke;

    setIsRevoked(computedRevoked);

    if (!user?.isOnboarding && !user?.isAdmin) {
      showToast("You need to finish onboarding!", "error");
    }
    // Раніше показували попередження та блокували вхід, доки адміністратори не підтвердять вік.
    // Тепер дозволяємо продовжити без цього очікування.

    setIsLoading(false);
  }, [user, history]);

  if (isLoading) {
    return <BaseLoading />;
  }

  // Редірект на choose-user-type тільки якщо:
  // 1. Користувач не пройшов onboarding (isOnboarding === false)
  // 2. Користувач не адмін
  // 3. Користувач не пройшов age proof
  // 4. Користувач НЕ вже на сторінці choose-user-type (щоб уникнути зациклення)
  if (!isValidated && !user?.isAdmin && !isAgeProofed && location.pathname !== "/choose-user-type") {
    return <Redirect to="/choose-user-type" />;
  }

  if (isRevoked) {
    return <AccountRevokedScreen />;
  }

  return <>{children}</>;
};

export default CheckAccess;
